// Single source of truth for the localStorage keys that make up a signed-in
// session, and the one function that tears them ALL down.
//
// Two code paths end a session: the manual logout / failed auth-check in
// context/AuthContext.jsx, and the 401 response interceptor in utils/api.js
// when a token expires mid-use. They used to clear these keys independently and
// drifted — the interceptor cleared only token+user, so an impersonated session
// that 401'd mid-use left `impersonating` + `adminToken` behind, and the red
// impersonation banner (which reads `impersonating` straight from localStorage)
// stayed stuck on /login with an orphaned admin token (Gemini review on #1606).
// Both paths now call clearSessionStorage, so they can never diverge again.

export const TOKEN_KEY = 'token'
export const USER_KEY = 'user'

// Set by the admin "impersonate" action (see AdminUsersPage + the
// ImpersonationBanner "Revenire la admin" handler in App.jsx): `adminToken`
// stashes the admin's own token so they can drop back, `impersonating` holds
// the impersonated identity that drives the banner. Both are part of the
// session and must die whenever it ends.
export const IMPERSONATION_KEYS = ['impersonating', 'adminToken']

/**
 * Remove every session key from localStorage. Safe to call when nothing is set
 * (each removeItem is a no-op) and in private-mode / storage-disabled contexts
 * (the whole thing is swallowed).
 */
export function clearSessionStorage() {
  try {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    for (const key of IMPERSONATION_KEYS) localStorage.removeItem(key)
  } catch {
    // Private-mode / storage-disabled — there's nothing to clear anyway.
  }
}
